import { gsap } from "gsap";

export function swichImgInit() {
  const targets = document.querySelectorAll(".js_swichTarget");
  if (!targets.length) return;

  targets.forEach((target) => {
    const imgs = target.querySelectorAll(".js_swichImg");
    if (imgs.length < 2) return;

    const [imgA, imgB] = imgs;

    // 最初の状態
    gsap.set(imgA, { opacity: 1 });
    gsap.set(imgB, { opacity: 0 });

    // 1秒ごとに切り替え（瞬間的に）
    const tl = gsap.timeline({ repeat: -1, repeatDelay: 0 });
    tl.to(imgA, { opacity: 0, duration: 0 })
      .to(imgB, { opacity: 1, duration: 0 }, "<") // ← 同時に切り替え
      .to({}, { duration: 1 }) // 表示1秒キープ
      .to(imgA, { opacity: 1, duration: 0 })
      .to(imgB, { opacity: 0, duration: 0 }, "<") // ← 同時に切り替え
      .to({}, { duration: 1 }); // 表示1秒キープ
  });
}